<template>
  <div id="water-level-chart" style="height: 650px">
    <div class="water-level-chart-title">培训完成人员情况</div>

    <div class="water-level-chart-details">
      已完成<span>{{ UserCount }}</span
      >人次培训
    </div>
    <div class="water-level-chart-details">占全体人员数量占比</div>

    <div class="chart-container">
      <dv-water-level-pond :config="config" :key="key" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaterLevelChart',
  data() {
    return {
      config: {
        data: [45],
        shape: 'round',
        waveHeight: 25,
        waveNum: 2
      },
      UserCount: 0,
      key: new Date().getTime()
    }
  },
  methods: {
    LoadData() {
      this.$matrix
        .AjaxGet3(
          'Users.Plan',
          'GetList',
          {
            GetCount: true,
            Page: 1,
            PageSize: 0,
            Groups: ['TrainState'],
            Fields: ['IdCount']
          },
          this.config.Role,
          this.config.RoleField
        )
        .then((data) => {
          if (data.Items && data.Items.length) {
            this.UserCount = data.Items.find((item) => {
              return item.TrainState === 2
            }).IdCount
            let total = data.Items.filter((t) => {
              return [2, 3].indexOf(t.TrainState) > -1
            }).reduce((t, n) => {
              return (t += n.IdCount)
            }, 0) 
            this.config.data = [((this.UserCount / total) * 100).toFixed(2)]

            this.key = new Date().getTime()
          }
        })
        .catch((e) => {
          this.$matrix.ShowError(e)
        })
    }
  },
  created() {
    this.LoadData()
  }
}
</script>

<style scoped>
#water-level-chart {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

#water-level-chart .water-level-chart-title {
  font-weight: 700;
  height: 50px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 20px;
}

#water-level-chart .water-level-chart-details,
#water-level-chart .water-level-chart-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

#water-level-chart .water-level-chart-details {
  height: 15%;
  font-size: 17px;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}

#water-level-chart .water-level-chart-details span {
  font-size: 35px;
  font-weight: 700;
  color: #58a1ff;
  margin: 0 5px;
  margin-bottom: -5px;
}

#water-level-chart .chart-container {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

#water-level-chart .dv-water-pond-level {
  max-width: 90%;
  width: 200px;
  height: 200px;
  border: 10px solid #19c3eb;
  border-radius: 50%;
}

#water-level-chart .dv-water-pond-level ellipse {
  stroke: transparent !important;
}

#water-level-chart .dv-water-pond-level text {
  font-size: 40px;
}
</style>